(() => {
  function initSection(section) {
    if (!section || section.dataset.benefitsInitialized === 'true') return;
    section.dataset.benefitsInitialized = 'true';
    const cards = section.querySelectorAll('.mb-card');
    if (section.dataset.enableReveal !== 'true' || !('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-in'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    cards.forEach((card) => observer.observe(card));
  }
  function init(scope = document) { scope.querySelectorAll('.marita-benefits').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
